export default __webpack_public_path__ + "static/media/wallpaper.930decd6.jpg";